export default function SafetySection() {
  return (
    <section id="safety" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
            Safety First
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mt-3 leading-tight">
            LitBuy Spreadsheet<br />
            Safety Guide
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Stay safe while shopping with spreadsheets. Follow these tips to protect yourself and make informed purchasing decisions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-10">
          {[
            {
              icon: 'ri-shield-check-line',
              title: 'Verify Seller Reputation',
              desc: 'Always cross-check seller ratings in the spreadsheet with their actual store ratings on LitBuy. Look for sellers with consistent positive feedback and long transaction histories.',
            },
            {
              icon: 'ri-scales-line',
              title: 'Compare Multiple Listings',
              desc: 'Never rely on a single listing. Use the spreadsheet to compare at least 3-4 sellers for the same product to identify fair pricing and quality differences.',
            },
            {
              icon: 'ri-error-warning-line',
              title: 'Avoid Unrealistic Prices',
              desc: 'If a price seems too good to be true, it probably is. Extremely low prices often indicate counterfeit products or scam sellers. Trust the community-vetted price ranges.',
            },
            {
              icon: 'ri-chat-check-line',
              title: 'Read Product Reviews',
              desc: 'Look for products with detailed buyer reviews and QC photos. Community feedback is one of the most reliable indicators of product quality and seller honesty.',
            },
            {
              icon: 'ri-lock-line',
              title: 'Use Secure Payment Methods',
              desc: 'Always use the official LitBuy payment system. Never send money directly to sellers outside the platform, as this bypasses buyer protection mechanisms.',
            },
            {
              icon: 'ri-file-list-3-line',
              title: 'Track Your Orders',
              desc: 'Keep a personal copy of your spreadsheet to track your own purchases, shipping updates, and QC photos. Documentation is your best protection if issues arise.',
            },
          ].map((item, i) => (
            <div
              key={i}
              className="flex gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70"
            >
              <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                <i className={`${item.icon} text-primary-600 text-lg`} />
              </span>
              <div>
                <h4 className="font-heading text-base font-bold text-foreground-900 mb-1">
                  {item.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
          <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
            Important Disclaimer
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed">
            This website is an independent informational resource. We do not sell products directly. 
            Always verify sellers and products before making purchasing decisions. Users are 
            responsible for their own transactions. The spreadsheet links and category pages 
            provided on this site redirect to third-party websites — we are not affiliated with 
            or endorsed by any specific seller or platform. Shop responsibly and always exercise 
            caution when making online purchases.
          </p>
        </div>
      </div>
    </section>
  );
}